import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IDocumentViewerItem } from '../../../common/sharedTypes';
import {
    REPORT_TYPE_BAC_ID,
    REPORT_TYPE_DRIVER_ID,
    REPORT_TYPE_FATAL_SUPPLEMENT_ID,
    REPORT_TYPE_INVESTIGATOR_ID,
    REPORT_TYPE_LETTERS_MEMOS_ID,
    REPORT_TYPE_NON_MOTORIST_SUPPLEMENT_ID,
    REPORT_TYPE_OTHER_ID,
    REPORT_TYPE_PHOTOS_ID,
    REPORT_TYPE_SPD_ID,
    REPORT_TYPE_TRUCK_BUS_SUPPLEMENT
} from '../../shared/constants';
import { b64toBlob } from '../../PrintPDF/common/utils';

// types
export enum DocumentViewerActionTypes {
  GET_ALL_DOCUMENTS = '@@DocumentViewer_SEARCH',
}

export const getAllDocuments = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    Api.get(url)
      .then((result: ApiResponse<any>) => {
        if (!result.ok) {
          console.error('DocumentViewer GetAllDocuments failed', {
            problem: result.problem,
            status: result.status,
            data: result.data,
            url,
          });
          reject(result);
          return;
        }

        dispatch(reduceResults(result.data));
        resolve(result.data);
      })
      .catch(function (ex) {
        console.error('DocumentViewer GetAllDocuments exception', ex);
        reject(ex);
      });
    // .finally(function () {
    //   resolve();
    // });
  });

export const reduceResults = (result: IDocumentViewerItem[]) => {
  if (!Array.isArray(result)) {
    console.error('DocumentViewer expected an array response', result);
    result = [];
  }

  // sort
  var ordering = {}, // map for efficient lookup of sortIndex
    sortOrder = [
      REPORT_TYPE_INVESTIGATOR_ID,
      REPORT_TYPE_DRIVER_ID,
      REPORT_TYPE_TRUCK_BUS_SUPPLEMENT,
      REPORT_TYPE_NON_MOTORIST_SUPPLEMENT_ID,
      REPORT_TYPE_SPD_ID,
      REPORT_TYPE_FATAL_SUPPLEMENT_ID,
      REPORT_TYPE_LETTERS_MEMOS_ID,
      REPORT_TYPE_PHOTOS_ID,
      REPORT_TYPE_BAC_ID,
      REPORT_TYPE_OTHER_ID];
  for (var i = 0; i < sortOrder.length; i++) ordering[sortOrder[i]] = i;

  result.sort(function (a, b) {
    return (
      ordering[a.reportType.id] -
      ordering[b.reportType.id] ||
      (a.reportType.id == 2 && a.sortOrder - b.sortOrder) ||
      a.sortOrder - b.sortOrder
    );
  });

  result.map(x => {
    try {
      if (x.data) {
        const file = b64toBlob(x.data, 'application/pdf');
        x.fileURL = URL.createObjectURL(file)
      }
    } catch (ex) {
      console.error('DocumentViewer failed to create PDF object URL', {
        reportId: x.reportId,
        documentId: x.documentId,
        source: x.source,
        dataLength: x.data?.length,
        error: ex,
      });
    }
  })

  return {
    type: DocumentViewerActionTypes.GET_ALL_DOCUMENTS,
    value: result,
  };
};

export const updateResults = (result: IDocumentViewerItem[]) => {
  return {
    type: DocumentViewerActionTypes.GET_ALL_DOCUMENTS,
    value: result,
  };
};
